module.exports = __webpack_public_path__ + "img/Unit_Guide_cans_strong.316c7c47.svg";